import React from "react";
import "./Search.css";
const Search = () => {
  return (
    <div id="left-search">
        <input id="left-chat-type" type="text" placeholder="Search or start new chat" />
      </div>
  );
};

export default Search;